import "./dlDetail.css";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import NewHeader from "../../components/NewHeader/NewHeader";
import Footer from "../../components/Footer/Footer";
import ImagingWhyUs from "../../components/Redcliffe-Imaging/ImagingWhyUs";
import DLTestimonial from "./DLTestimonials";
import { BsChevronDown } from "react-icons/bs";
import DLActions from "./DLActions";
import DldetailForm from "./DldetailForm";
import Modal from "react-responsive-modal";
import { useLocation, useHistory } from "react-router-dom";

const DLDetail = (props) => {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const location = useLocation();
  const history = useHistory();
  console.log(location.pathname, "pathname");

  const city = props.match.params.cityslug
  console.log(city,"===> city")

  let googleLogo =
    "https://staticcdn.redcliffelabs.com/media/gallary-file/None/33507b7b-3dc2-4ef8-b7ef-572d177f5216.png";
  const [width, setWidth] = useState("");
  const [subcenters, setSubcenter] = useState([]);
  const [cheapPackage, setCheapPackage] = useState([]);
  const [finalCompleteObject, setFinalCompleteObject] = useState([]);
  const [newArry, setnewArry] = useState([]);

  useEffect(() => {
    props?.getImagingCenter(props?.match?.params?.slug);
    function updateSize() {
      if (typeof window !== "undefined") {
        setWidth(window.screen.width);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    props?.subCenterList &&
      props?.subCenterList?.map((item) => {
        props?.getRelatedSubcenterPackage(item?.id);
      });
    setSubcenter(props?.subCenterList);
  }, [props?.subCenterList]);

  useEffect(() => {
      props?.getNearbyCities(city);
  }, [city]);

  useEffect(() => {
    console.log(props?.centerData?.center?.id, ">>>>>>>>>>");
    if (props?.centerData?.center?.id) {
      props?.getSubCenterFromId(props?.centerData?.center?.id);
    }
  }, [props?.centerData?.center?.id]);

  useEffect(() => {
    if (cheapPackage.includes(props?.cheapPackages)) {
    } else {
      if (props?.cheapPackages.length > 0) {
        cheapPackage.push(props?.cheapPackages);
      }
    }
  }, [props?.cheapPackages]);

  useEffect(() => {
    subcenters?.forEach((center) => {
      cheapPackage?.forEach((pack) => {
        if (center?.id == parseInt(pack && pack[0]?.center_address_id)) {
          newArry?.push({
            ...center,
            cheapPackage: pack && pack[1] && pack[1]?.packages,
          });
        }
      });
    });
    const uniqueList = newArry.filter(
      (v, i, a) => a.findIndex((v2) => v2.id === v.id) === i
    );
    setFinalCompleteObject(uniqueList);
  }, [subcenters, cheapPackage, props?.cheapPackages]);

  const pushPage = (slug) => {
    history.push(`/${city}/imgaging/${slug}`);
  }

  return (
    <div>
      <NewHeader />

      {/* Sec 1 */}

      <div className="dldetail_sec1 container">
        <div className="dldetail_sec1Discountdiv">
          <p className="dldetail_sec1DiscountText">
            Get {props?.centerData?.discount}% Off
          </p>
          <p className="dldetail_sec1InstituteName">
            At {props?.centerData?.center?.name}
          </p>
          <p className="dldetail_sec1BookText">Book Appointment Now</p>
        </div>
        {width < 481 ? (
          <div className="dldetail_sec1Img">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/ad61f293-b6ba-42ba-acf2-720882e3c945.png"
              alt="Banner Image"
            />
            <span className="discountText">{props?.centerData?.discount}%</span>
            <span className="centerNameText">
              {props?.centerData?.center?.name}
            </span>
          </div>
        ) : (
          <div className="dldetail_sec1Img">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/98ec2928-2417-4daa-943f-353e996831c5.png"
              alt="Banner Image"
            />
            <span className="discountText">{props?.centerData?.discount}%</span>
            <span className="centerNameText">
              {props?.centerData?.center?.name}
            </span>
          </div>
        )}
        <div className="dldetail_sec1Text">
          <p className="dldetail_heading">
            {props?.centerData?.center?.name},
            {props?.centerData?.location?.area},
            {props?.centerData?.location?.display_name}
          </p>
          <p className="dldetail_para">{props?.centerData?.introduction}</p>
        </div>
      </div>

      {/* Sec 2 */}

      <div className="dldetail_bgc">
        <div className="dldetail_sec2 container">
          <p className="dldetail_heading">Services :</p>
          <div className="dldetail_sec2Cards">
            {props?.centerData?.services?.includes("MRI") ? (
              <div className="dldetail_sec2Card">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/beb692c8-c337-4161-8704-91f4f9aa9791.png"
                  alt="card icon"
                />
                <p className="dldetail_sec2CardHeading">MRI Scan</p>
              </div>
            ) : null}

            {props?.centerData?.services?.includes("CT") ? (
              <div className="dldetail_sec2Card">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/a602bf88-e684-4a79-9b96-897879b8168a.png"
                  alt="card icon"
                />
                <p className="dldetail_sec2CardHeading">CT Scan</p>
              </div>
            ) : null}

            {props?.centerData?.services?.includes("USG") ? (
              <div className="dldetail_sec2Card">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/c04a56df-8f30-4ae2-a757-f776bdf6f3d0.png"
                  alt="card icon"
                />
                <p className="dldetail_sec2CardHeading">Ultrasound</p>
              </div>
            ) : null}

            {props?.centerData?.services?.includes("XRay") ? (
              <div className="dldetail_sec2Card">
                <img
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/636a36fb-840e-4f7f-afed-332a1d77d065.png"
                  alt="card icon"
                />
                <p className="dldetail_sec2CardHeading">X-Ray</p>
              </div>
            ) : null}
          </div>
          <p className="dldetail_para">
            Book tests and avail {props?.centerData?.discount}% Off on several
            tests. By scheduling your appointment according to your preference,
            we help you in reducing long waiting times and make your experience
            hassle-free and convenient.
          </p>
        </div>
      </div>

      {/* Sec 3 */}

      <div className="dldetail_sec3 container">
        <p className="dldetail_heading">
          You can avail services and discounts at our following branches:
        </p>

        <div className="dldetail_sec3Para">
          {/* {props?.} */}

          {props?.subCenterList?.length > 0
            ? props?.subCenterList?.map((item) => {
                return (
                  <div className="dldetail_sec3Item">
                    <img
                      src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/677306bb-5e8a-497b-8815-533e8d3db50a.png"
                      alt="Check Mark Icon"
                    />
                    <p>
                      {item?.center?.name}, {item?.location?.area}
                    </p>
                  </div>
                );
              })
            : null}

          {/* <div className="dldetail_sec3Item">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/677306bb-5e8a-497b-8815-533e8d3db50a.png"
              alt="Check Mark Icon"
            />
            <p>Dr. Gulati Imaging Institute, Dwarka, Delhi</p>
          </div> */}
        </div>
      </div>

      {/* Sec 4 */}

      <div className="dldetail_bgc dldetail_bgcMobile">
        <div className="dldetail_sec4 container">
          <div className="dldetail_sec4Img">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/20bce58a-1c96-4d13-b721-f5d048545276.png"
              alt="Check Mark Icon"
            />
            <p className="dldetail_sec4Text">Book an Appointment now!</p>
          </div>

          <div className="dldetail_sec4Btns">
            <button
              className="dldetail_sec4Btn1"
              onClick={() => {
                onOpenModal();
              }}
            >
              REQUEST A CALLBACK
            </button>
            <a className="dldetail_sec4Btn2" href="tel:+91 898 898 0101">
              898 898 0101
            </a>
          </div>
        </div>
      </div>

      {/* Sec 5 */}

      <div className="dldetail_sec5 container">
        <ImagingWhyUs />
      </div>

      {/* Sec 6 */}
      <div className="dldetail_bgc6">
        <div className="dldetail_sec6 container">
          <p className="dldetail_sec6Heading">
            Benefits of booking tests through Redcliffe Imaging
          </p>
          <ul className="dldetail_sec6List">
            <li className="dldetail_sec6Listitem">
              Avail a {props?.centerData?.discount}% discount at{" "}
              {props?.centerData?.center?.name}
            </li>
            <li className="dldetail_sec6Listitem">
              Complete assistance right from booking an appointment until final
              reports delivery
            </li>
            <li className="dldetail_sec6Listitem">
              Avail radiology services at 2 {props?.centerData?.center?.name}
            </li>
            <li className="dldetail_sec6Listitem">
              Skilled radiologists and expert customer care service
            </li>
          </ul>
        </div>
      </div>

      {/* Sec 7 */}

      <div className="dldetail_sec7 container">
        <p className="dldetail_heading">
          {props?.centerData?.center?.name} –{" "}
          {props?.centerData?.location?.display_name}’s most sought-after
          imaging lab
        </p>

        <p className="dldetail_para">
          {props?.centerData?.tagline_description}
        </p>

        <div className="dldetail_sec3Para">
          <p className="dldetail_sec7ListHeading">
            Key Radiology Tests at {props?.centerData?.center?.name}
          </p>
          {props?.centerData?.services?.length > 0
            ? props?.centerData?.services?.map((item) => {
                return (
                  <div className="dldetail_sec3Item">
                    <img
                      src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/677306bb-5e8a-497b-8815-533e8d3db50a.png"
                      alt="Check Mark Icon"
                    />
                    <p>{item}</p>
                  </div>
                );
              })
            : null}
        </div>

        <div className="dldetail_sec7Text1">
          <p className="dldetail_heading">
            Location Of {props?.centerData?.center?.name}
          </p>

          <p className="dldetail_para">
            {props?.centerData?.Location_of_center_brief}
          </p>
        </div>

        <div>
          <p className="dldetail_heading">
            Cost of imaging procedures at {props?.centerData?.center?.name}
          </p>

          <p className="dldetail_para">
            {props?.centerData?.Cost_of_services_brief}
          </p>
        </div>
      </div>

      {/* Sec 8 */}

      {finalCompleteObject?.length > 0
        ? finalCompleteObject?.map((item) => {
            console.log(item?.cheapPackage, "item<<");
            return (
              <div className="dldetail_bgc">
                <div className="dldetail_sec8 container">
                  <table className="dldetailTable">
                    <caption className="dldetail_heading">
                      {item?.center?.name}
                    </caption>
                    <tr>
                      <th>
                        Medical tests at {item?.center?.name},
                        <br /> {item?.location?.area}
                      </th>
                      <th>
                        Cost of procedures
                        <br /> through
                        <br /> Redcliffe Labs
                      </th>
                    </tr>
                    {item?.cheapPackage &&
                      item?.cheapPackage.map((para, index) => {
                        return (
                          <tr>
                            <td>{para?.package_type}</td>
                            <td>{para?.package_price}</td>
                          </tr>
                        );
                      })}

                    <tr className="viewMore_tr">
                      <td colspan="2">
                        <div className="viewMore_trDiv">
                          <span>View more</span> <BsChevronDown />
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            );
          })
        : null}

      <div className="btnContainer container">
        <button className="dldetail_sec9Btn">View More Centers</button>
      </div>

      {/* Sec 9 */}

      {/* <div className="dldetail_sec9 container">
        <table className="dldetailTable">
          <caption className="dldetail_heading">
            Dr. Gulati Imaging Institute, Dwarka
          </caption>
          <tr>
            <th>
              Medical tests at Dr. Gulati
              <br /> Imaging Institute,
              <br /> Dwarka
            </th>
            <th>
              Cost of procedures
              <br /> through
              <br /> Redcliffe Labs
            </th>
          </tr>

          <tr>
            <td>MRI Scan</td>
            <td></td>
          </tr>

          <tr>
            <td>CT Scan</td>
            <td></td>
          </tr>

          <tr>
            <td>Ultrasound</td>
            <td></td>
          </tr>

          <tr>
            <td>X-ray</td>
            <td></td>
          </tr>

          <tr className="viewMore_tr">
            <td colspan="2">
              <div className="viewMore_trDiv">
                <span>View more</span> <BsChevronDown />
              </div>
            </td>
          </tr>
        </table>
        <button className="dldetail_sec9Btn">View More Centers</button>
      </div> */}

      {/* Sec 10 */}
      <div className="dldetail_bgc">
        <div className="dldetail_sec10 container">
          <DLTestimonial
            title="Reviews"
            Ispackage={false}
            isTestimonial={true}
            googleLogo={googleLogo}
          />
        </div>
      </div>

      {/* Sec 11 */}

      <div className="dldetail_sec11 container">
        <p className="dldetail_heading">Nearby Centers</p>
        {props?.nearbyCitiesList?.length > 0
          ? props?.nearbyCitiesList?.map((item) => {
            console.log(item, "<<item")
              return (
                <ul>
                  <li>
                    <a onClick={() => pushPage(item.slug)}>{item?.center?.name}</a>
                  </li>
                </ul>
              );
            })
          : null}
      </div>

      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "dldetail_modal",
        }}
        open={open}
        onClose={onCloseModal}
        center
      >
        <DldetailForm />
      </Modal>

      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  centerData: state?.DLReducers?.ImagingCentreData[0],
  cheapPackages: state?.DLReducers?.ImagingCheapPackage,
  subCenterList: state?.DLReducers?.ImagingSubCentreList,
  nearbyCitiesList: state?.DLReducers?.ImagingNearbyCitiesList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getImagingCenter: (slug) => {
      dispatch(DLActions.getImagingCenter(slug));
    },
    getRelatedSubcenterPackage: (id) => {
      dispatch(DLActions.getRelatedSubcenterPackage(id));
    },
    getSubCenterFromId: (id) => {
      dispatch(DLActions.getSubCenterFromId(id));
    },
    getNearbyCities: (city) => {
      dispatch(DLActions.getNearbyCities(city));
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(DLDetail)),
};
